export default __webpack_public_path__ + "static/media/b-12.42bcaff0.png";